import React from 'react';
import './Pages/PagesCss/PrivacyPolicy.css';

const TermsConditions = () => {
  return (
    <div className="privacy-policy">
      {/* Header Section */}
      <section className="policy-header">
        <div className="container">
          <div className="header-content">
            <h1>Terms & Conditions</h1>
            <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            <p className="header-description">
              Welcome to noobtobull. These terms and conditions outline the rules and regulations 
              for the use of our financial calculator services and website.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="policy-content">
        <div className="container">
          <div className="policy-grid">
            {/* Table of Contents */}
            <aside className="table-of-contents">
              <h3>Table of Contents</h3>
              <nav>
                <ul>
                  <li><a href="#acceptance">Acceptance of Terms</a></li>
                  <li><a href="#services">Services Description</a></li>
                  <li><a href="#user-responsibilities">User Responsibilities</a></li>
                  <li><a href="#intellectual-property">Intellectual Property</a></li>
                  <li><a href="#disclaimer">Disclaimer</a></li>
                  <li><a href="#limitation-liability">Limitation of Liability</a></li>
                  <li><a href="#user-content">User Content</a></li>
                  <li><a href="#third-party">Third-Party Links</a></li>
                  <li><a href="#termination">Termination</a></li>
                  <li><a href="#governing-law">Governing Law</a></li>
                  <li><a href="#changes">Changes to Terms</a></li>
                  <li><a href="#contact">Contact Information</a></li>
                </ul>
              </nav>
            </aside>

            {/* Terms Sections */}
            <div className="policy-sections">
              <section id="acceptance" className="policy-section">
                <h2>1. Acceptance of Terms</h2>
                <div className="section-content">
                  <p>
                    By accessing and using noobtobull ("the Service"), you accept and agree to be bound 
                    by the terms and provision of this agreement. If you do not agree to abide by these 
                    terms, please do not use this Service.
                  </p>
                  <p>
  These Terms & Conditions apply to all websites and subdomains operated by D-Tech Studios for noobtobull, including <a href="https://noobtobull.com" target="_blank" rel="noopener noreferrer">https://noobtobull.com</a> and <a href="https://blog.noobtobull.com" target="_blank" rel="noopener noreferrer">https://blog.noobtobull.com</a>.
</p>

                  <p>
                    These Terms apply to all visitors, users, and others who access or use the Service. 
                    Additional terms may apply to specific services and are incorporated by reference.
                  </p>
                </div>
              </section>

              <section id="services" className="policy-section">
                <h2>2. Services Description</h2>
                <div className="section-content">
                  <h3>2.1 Financial Calculator Tools</h3>
                  <p>
                    noobtobull provides a suite of financial calculators including but not limited to:
                  </p>
                  <ul>
                    <li>Profit and ROI calculators for trading</li>
                    <li>Investment planning tools</li>
                    <li>Risk management calculators</li>
                    <li>Tax calculation tools</li>
                    <li>Retirement planning calculators</li>
                  </ul>

                  <h3>2.2 Educational Purpose</h3>
                  <p>
                    Our calculators are designed for educational and informational purposes only. 
                    They should not be considered as financial advice, investment recommendations, 
                    or substitute for professional financial consultation.
                  </p>

                  <h3>2.3 Service Availability</h3>
                  <p>
                    We strive to maintain 24/7 service availability but do not guarantee uninterrupted 
                    access. We may temporarily suspend access for maintenance, updates, or technical reasons.
                  </p>
                </div>
              </section>

              <section id="user-responsibilities" className="policy-section">
                <h2>3. User Responsibilities</h2>
                <div className="section-content">
                  <h3>3.1 Account Security</h3>
                  <p>
                    If you create an account with us, you are responsible for maintaining the 
                    confidentiality of your account and password and for restricting access to your computer.
                  </p>

                  <h3>3.2 Proper Use</h3>
                  <p>You agree to use the Service only for lawful purposes and in a way that does not:</p>
                  <ul>
                    <li>Infringe the rights of any third party</li>
                    <li>Violate any applicable laws or regulations</li>
                    <li>Disrupt or interfere with our Service or servers</li>
                    <li>Attempt to gain unauthorized access to any part of the Service</li>
                  </ul>

                  <h3>3.3 Age Requirement</h3>
                  <p>
                    You must be at least 18 years old to use our Service. By using the Service, 
                    you represent that you are at least 18 years of age.
                  </p>
                </div>
              </section>

              <section id="intellectual-property" className="policy-section">
                <h2>4. Intellectual Property Rights</h2>
                <div className="section-content">
                  <p>
                    The Service and its original content, features, and functionality are owned by 
                    noobtobull and are protected by international copyright, trademark, patent, 
                    trade secret, and other intellectual property laws.
                  </p>

                  <h3>4.1 License Grant</h3>
                  <p>
                    We grant you a limited, non-exclusive, non-transferable, revocable license to 
                    use our Service for personal, non-commercial purposes subject to these Terms.
                  </p>

                  <h3>4.2 Restrictions</h3>
                  <p>You may not:</p>
                  <ul>
                    <li>Copy, modify, or create derivative works of the Service</li>
                    <li>Reverse engineer or attempt to extract the source code</li>
                    <li>Use the Service for any commercial purpose without our express written consent</li>
                    <li>Remove any copyright or other proprietary notices from the Service</li>
                  </ul>
                </div>
              </section>

              <section id="disclaimer" className="policy-section">
                <h2>5. Disclaimer of Warranties</h2>
                <div className="section-content">
                  <div className="security-features">
                    <h3>Important Disclaimer</h3>
                    <p>
                      <strong>Our financial calculators are provided for educational and informational 
                      purposes only.</strong> They are not financial advice and should not be relied upon 
                      for making investment decisions.
                    </p>
                  </div>

                  <h3>5.1 No Financial Advice</h3>
                  <p>
                    The results provided by our calculators are estimates based on the information 
                    you provide. We do not guarantee the accuracy, completeness, or reliability of 
                    any calculations or information provided by the Service.
                  </p>

                  <h3>5.2 "As Is" Service</h3>
                  <p>
                    The Service is provided on an "AS IS" and "AS AVAILABLE" basis. We make no 
                    warranties, expressed or implied, regarding the Service's reliability, 
                    availability, or ability to meet your needs.
                  </p>

                  <h3>5.3 Professional Advice</h3>
                  <p>
                    Always consult with qualified financial advisors, accountants, or other 
                    professionals before making any financial decisions. Our tools are meant to 
                    supplement, not replace, professional advice.
                  </p>
                </div>
              </section>

              <section id="limitation-liability" className="policy-section">
                <h2>6. Limitation of Liability</h2>
                <div className="section-content">
                  <p>
                    To the fullest extent permitted by applicable law, noobtobull shall not be 
                    liable for any indirect, incidental, special, consequential, or punitive damages, 
                    including without limitation, loss of profits, data, use, goodwill, or other 
                    intangible losses, resulting from:
                  </p>
                  <ul>
                    <li>Your use or inability to use the Service</li>
                    <li>Any conduct or content of any third party on the Service</li>
                    <li>Any content obtained from the Service</li>
                    <li>Unauthorized access, use, or alteration of your transmissions or content</li>
                  </ul>

                  <h3>6.1 Financial Decisions</h3>
                  <p>
                    We are not responsible for any financial losses or damages resulting from 
                    decisions made based on calculations from our Service. Users assume all 
                    responsibility and risk for their financial decisions.
                  </p>

                  <h3>6.2 Maximum Liability</h3>
                  <p>
                    In no event shall our total liability to you for all damages exceed zero dollars ($0.00 USD), as this tool is provided free of charge.
                  </p>
                </div>
              </section>

              <section id="user-content" className="policy-section">
                <h2>7. User Content</h2>
                <div className="section-content">
                  <h3>7.1 Content Ownership</h3>
                  <p>
                    You retain ownership of any financial data you input into our calculators. 
                    However, by submitting content to us, you grant us a worldwide, non-exclusive, 
                    royalty-free license to use, reproduce, and analyze such content to improve our Services.
                  </p>

                  <h3>7.2 Content Responsibility</h3>
                  <p>
                    You are solely responsible for the content you submit and the consequences of 
                    posting or publishing it. You represent that you have the right to submit any 
                    content you provide.
                  </p>
                </div>
              </section>

              <section id="third-party" className="policy-section">
                <h2>8. Third-Party Links and Services</h2>
                <div className="section-content">
                  <p>
                    Our Service may contain links to third-party websites or services that are 
                    not owned or controlled by noobtobull.
                  </p>

                  <h3>8.1 No Endorsement</h3>
                  <p>
                    We have no control over, and assume no responsibility for, the content, 
                    privacy policies, or practices of any third-party websites or services.
                  </p>

                  <h3>8.2 External Sites</h3>
                  <p>
                    You acknowledge and agree that we shall not be responsible or liable, directly 
                    or indirectly, for any damage or loss caused by or in connection with use of 
                    any such content, goods, or services available on or through any such websites 
                    or services.
                  </p>
                </div>
              </section>

              <section id="termination" className="policy-section">
                <h2>9. Termination</h2>
                <div className="section-content">
                  <p>
                    We may terminate or suspend your access to our Service immediately, without 
                    prior notice or liability, for any reason whatsoever, including without 
                    limitation if you breach the Terms.
                  </p>

                  <h3>9.1 User Termination</h3>
                  <p>
                    You may stop using our Service at any time. If you wish to delete your account, 
                    please contact us at support@noobtobull.com.
                  </p>

                  <h3>9.2 Effect of Termination</h3>
                  <p>
                    Upon termination, your right to use the Service will immediately cease. All 
                    provisions of the Terms which by their nature should survive termination shall 
                    survive termination, including ownership provisions, warranty disclaimers, 
                    indemnity, and limitations of liability.
                  </p>
                </div>
              </section>

              <section id="governing-law" className="policy-section">
                <h2>10. Governing Law</h2>
                <div className="section-content">
                  <p>
                    These Terms shall be governed and construed in accordance with the laws of 
                    the State of New York, United States, without regard to its conflict of law provisions.
                  </p>

                  <h3>10.1 Jurisdiction</h3>
                  <p>
                    Any legal disputes shall be resolved in the state or federal courts located 
                    in New York County, New York.
                  </p>

                  <h3>10.2 International Use</h3>
                  <p>
                    We make no representation that our Service is appropriate or available for 
                    use in other locations. Those who access or use the Service from other 
                    jurisdictions do so at their own volition and are responsible for compliance 
                    with local law.
                  </p>
                </div>
              </section>

              <section id="changes" className="policy-section">
                <h2>11. Changes to Terms</h2>
                <div className="section-content">
                  <p>
                    We reserve the right, at our sole discretion, to modify or replace these 
                    Terms at any time. If a revision is material, we will provide at least 
                    30 days' notice prior to any new terms taking effect.
                  </p>

                  <h3>11.1 Continued Use</h3>
                  <p>
                    By continuing to access or use our Service after those revisions become 
                    effective, you agree to be bound by the revised terms. If you do not agree 
                    to the new terms, please stop using the Service.
                  </p>
                </div>
              </section>

              <section id="contact" className="policy-section">
                <h2>12. Contact Information</h2>
                <div className="section-content">
                  <p>
                    If you have any questions about these Terms, please contact us:
                  </p>
                  <div className="contact-info">
                    <div className="contact-item">
                      <strong>Email:</strong> support@noobtobull.com
                    </div>
                    <div className="contact-item">
                      <strong>Address:</strong> 2568 Madison Ave, League City, TX 77573
                    </div>
                    <div className="contact-item">
                      <strong>Response Time:</strong> We typically respond to legal inquiries within 3-5 business days
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Actions */}
      <section className="policy-actions">
        <div className="container">
          <div className="actions-content">
            <h3>Questions About Our Terms?</h3>
            <p>If you need clarification on any part of our Terms & Conditions, don't hesitate to reach out.</p>
            <div className="action-buttons">
              <a href="/Contact" className="btn btn-primary">Contact Support</a>
              <a href="/RiskRewardCalculator" className="btn btn-secondary">View Our Calculators</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;